import React from 'react'

import Tooltip from '../tooltip'

type Props = {
  label: React.ReactNode
  htmlFor?: string
  size?: 'sm' | 'md' | 'lg'
  tooltip?: string
  className?: string
  required?: boolean
  optional?: boolean
}

const FieldLabel: React.FC<Props> = ({ label, htmlFor, size = 'md', tooltip, className, required, optional }) => {
  const showOptionalBadge = optional && !required

  return (
    <label
      htmlFor={htmlFor}
      className={`form-label ${className || ''}`.trim()}
    >
      <span className={size === 'md' ? 'bold-label' : 'light-label'}>{label}</span>
      {required && (
        <span className='field-label-required text-danger' aria-hidden='true'> *</span>
      )}
      {showOptionalBadge && (
        <span className='field-label-optional badge rounded-pill bg-light text-body-secondary'>
          Optional
        </span>
      )}
      <Tooltip message={tooltip} />
    </label>
  )
}

export default FieldLabel
